import styled from "styled-components";

export const ChartContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 24px;
    box-sizing: border-box;
    gap: 24px;

    > * {
        flex: 1;
    }
`;
